/**
 * Tempo restante da sessão de suporte para o banner: `m:ss` abaixo de 1 hora
 * (`14:59`, `0:07`) e `h:mm:ss` a partir dela (`1:00:00`). A duração é
 * escolhida no Admin (5/15/30/45 min desde 21/10/2026), então hoje o ramo de
 * hora não aparece; ele existe para que um teto maior no futuro nunca vire
 * `60:00`/`90:00`. Data inválida ou já vencida = `0:00`.
 */
export function formatRemaining(expiresAt: string, nowMs: number): string {
  const fim = new Date(expiresAt).getTime();
  const diff = Number.isFinite(fim) ? Math.max(0, fim - nowMs) : 0;
  const totalSec = Math.floor(diff / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const ss = s.toString().padStart(2, "0");
  if (h > 0) return `${h}:${m.toString().padStart(2, "0")}:${ss}`;
  return `${m}:${ss}`;
}
